export const caseStudies = [
  {
    slug: 'fishbuddy',
    client: 'Fishbuddy App',
    logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/fg3f65j9_Fishbuddy-by-fiskher_Liggende.png',
    title: 'Scaling Fishbuddy across 5 European markets',
    category: 'App Growth',
    duration: 'Mar – Sept 2025',
    budget: '$100,000+',
    role: 'App Growth & Performance Marketing Strategist',
    challenge:
      'Fishbuddy had strong traction in Norway, but needed to scale user growth and paid subscriptions in Germany, the Netherlands, Sweden, Denmark and Austria. The core constraint was efficiency: reach a niche audience of sports anglers and outdoor enthusiasts with country-specific relevance while keeping acquisition costs under control.',
    approach:
      'Built a country-by-country growth engine combining localized creative, feature-led messaging, influencer content, App Store Optimization and full-funnel paid media. Campaigns were tracked through GA4, AppsFlyer and Looker Studio, with continuous optimization against cost per install, subscription intent and revenue per user.',
    results: [
      { value: '+50%', label: 'Total installs over the season' },
      { value: '<$1', label: 'Cost per install achieved' },
      { value: '1M+', label: 'Total downloads crossed' },
      { value: '+60%', label: 'Subscriber revenue growth' },
      { value: '+35%', label: 'App Store conversion rate' },
    ],
    services: [
      'Meta Ads',
      'Google Ads',
      'Apple Search Ads',
      'TikTok Ads',
      'ASO',
      'Influencer Marketing',
      'Retargeting',
    ],
    takeaway:
      'The winning mix was localized creative plus channel-specific optimization: Meta and Apple Search Ads led iOS performance, while Google App Campaigns delivered the strongest Android download efficiency.',
  },
  {
    slug: 'ican',
    client: 'ICAN — International Campaign to Abolish Nuclear Weapons',
    logo: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/uzk74gxf_ICAN%20Nobel%20logo.svg',
    title: 'Turning the 80 Years moment into measurable social growth',
    category: 'Non-Profit Growth',
    duration: 'June – Sept 2025',
    budget: '2,700 CHF (TikTok)',
    role: 'Social Growth Strategist',
    challenge:
      'ICAN needed to use the 80 Years campaign moment to convert public awareness around nuclear weapons into measurable social engagement, follower growth and traffic to its website across priority social channels.',
    approach:
      'The campaign combined boosted posts, video ads and follow-focused CTAs across Instagram, Facebook and TikTok. Creative testing focused on high-engagement formats, country-specific pushes, always-on post boosts and clear in-post calls to action to drive engagement, profile growth and site visits.',
    results: [
      { value: '1.1M', label: 'Instagram reach (+386.9%)' },
      { value: '1.9M', label: 'Facebook views (+9.7K%)' },
      { value: '2.2M', label: 'TikTok impressions' },
      { value: '57.6K', label: 'New TikTok followers' },
      { value: '72K', label: 'TikTok clicks (CHF 2.7K spend)' },
      { value: '17.5K', label: 'Instagram link clicks' },
      { value: '159.1K', label: 'Facebook interactions' },
      { value: '7.3K', label: 'Facebook link clicks → site' },
    ],
    services: [
      'Instagram Ads',
      'Facebook Boosts',
      'TikTok Ads',
      'Video Ads',
      'Website Traffic',
      'Engagement Campaigns',
      'Follower Growth',
      'Regional Campaigns',
    ],
    takeaway:
      'Advocacy content can scale when strong issue-led creative is paired with channel-specific paid tactics: video drove attention, boosted posts sustained engagement, and TikTok delivered efficient follower growth at scale.',
  },
  {
    slug: 'skida',
    client: 'Skida App',
    logo: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/dmpd42y4_LogoIndigo-%402x.png',
    title: 'Building a full-funnel app growth engine before peak ski season',
    category: 'App Growth',
    duration: 'Mar – May 2025',
    budget: '22K NOK media baseline',
    role: 'App Growth & Performance Marketing Strategist',
    challenge:
      'Skida had early traction across iOS and Android, but needed a sharper growth system before peak season: lower cost per install, stronger paid conversion, improved store conversion and market-specific acquisition in high-potential ski touring regions such as the UK and Switzerland.',
    approach:
      'Rebalanced acquisition towards iOS, prioritized Apple Search Ads and Google App campaigns, and expanded into Meta, TikTok and micro-influencer content. The plan combined localized ads, App Store Optimization, improved ratings/reviews, free-trial prompts, push/in-app messaging, referral loops and potential resort or ski-organization partnerships.',
    results: [
      { value: '2.4K', label: 'Installs across Play & App Store' },
      { value: '9.4 kr', label: 'Average cost per install' },
      { value: '31.3K', label: 'Android store visitors' },
      { value: '1.11K', label: 'iOS downloads in February' },
      { value: '4.1%', label: 'iOS conversion to paying users' },
    ],
    services: [
      'Apple Search Ads',
      'Google Ads',
      'Meta Ads',
      'TikTok Ads',
      'ASO',
      'Micro-Influencers',
      'Push / In-app Messaging',
      'Referrals',
    ],
    takeaway:
      'Paid search was already producing efficient installs — the next step was a full-funnel app growth engine: 60% iOS budget focus, stronger ASO, localized creative for priority markets, and monetization loops through trials, push messaging and referrals.',
  },
  {
    slug: 'ymir',
    client: 'YM:R Labs',
    logo: 'https://customer-assets.emergentagent.com/job_03e046c2-c54d-47da-b894-273efa8f8020/artifacts/7wg3qab8_ymirlabsstartupstudio_logo.jpeg',
    title: 'Startup Studio — B2B Lead Generation funnel',
    category: 'B2B Performance Marketing',
    duration: 'H2 2023',
    budget: '64,731 NOK',
    role: 'B2B Lead Generation Strategist',
    challenge:
      'YM:R Labs needed to attract founders, startup operators and corporate innovation profiles into its startup studio program — a niche B2B audience that required trust, clarity and a considered decision before applying. The challenge was not just to drive traffic, but to communicate a complex startup studio model clearly enough for the right people to understand the opportunity and take action.',
    approach:
      'A performance-led funnel combining three core components — multi-channel acquisition (Facebook for founder storytelling, LinkedIn for professional targeting by job title and seniority, Google Performance Max for intent-based discovery), an editorial long-copy landing page explaining the YM:R model, and continuous creative + landing page optimisation with shorter variants iterated from winning ad themes.',
    results: [
      { value: '94', label: 'Total inbound leads generated' },
      { value: '689 NOK', label: 'Average cost per lead (all channels)' },
      { value: '336 NOK', label: 'Facebook CPL — best performing' },
      { value: '75', label: 'Leads from Facebook (80% of total)' },
      { value: '+275%', label: 'LinkedIn landing-page CVR lift' },
      { value: '64,731 NOK', label: 'Total media spend' },
      { value: '25,173 NOK', label: 'Facebook spend' },
      { value: '28,437 NOK', label: 'LinkedIn spend' },
      { value: '11,121 NOK', label: 'Google Performance Max spend' },
      { value: '1,011 NOK', label: 'Google PMax CPL' },
    ],
    services: [
      'Facebook Ads',
      'LinkedIn Ads',
      'Google Performance Max',
      'Landing Page Testing',
      'Creative Optimisation',
      'B2B Marketing',
      'Lead Generation',
    ],
    takeaway:
      'Facebook was the most efficient channel — founder storytelling and emotional messaging outperformed formal B2B ads. LinkedIn required sharper landing-page alignment; a shorter variant lifted CVR by 275%. Google Performance Max improved significantly after optimisation, halving CPL by October. Cross-channel learning was key — winning Facebook messages improved Performance Max assets and LinkedIn pages.',
  },
  {
    slug: 'ntl',
    client: 'NTL — Norsk Tjenestemannslag',
    logo: '/ntl-logo.png',
    title: 'Membership Growth Campaign for Norway\u2019s largest public-sector union',
    category: 'B2C Performance Marketing',
    duration: 'February – April 2026',
    budget: 'Multi-channel video',
    role: 'Performance Marketing & Video Campaign Lead',
    challenge:
      'Norway\u2019s largest public-sector trade union (58,000+ members) needed to grow its membership base and build awareness as the preferred employee organisation for government and public-sector workers across Norway. The campaign targeted a specific, hard-to-reach audience via a video-only paid media approach across Meta and LinkedIn, with the goal of driving traffic to the membership sign-up page and converting interest into new memberships.',
    approach:
      'A dual-channel video campaign combining broad Meta reach with precision LinkedIn targeting built around awareness, traffic and conversion objectives. Meta ran video-only ads with three creative routes (Kontorstol, Papirfly, Pannekast). LinkedIn used company-list targeting of Norwegian public organisations across seniority levels with seven video variants, weighting budget toward the strongest performer (Ad2 Long 50 sec). Traffic was sent to the /seforskjellen membership page, monitored via GA4 for CTA clicks and form submissions, with continuous budget shifts toward top-performing creatives.',
    results: [
      { value: '+300%', label: 'New member sign-ups during campaign' },
      { value: 'NOK 2.15', label: 'Cost per landing-page view (Meta)' },
      { value: '5,111', label: 'Landing-page views from Meta' },
      { value: '73,690', label: 'LinkedIn video views' },
      { value: '~4,000', label: 'Become-a-Member CTA clicks (GA4)' },
      { value: '316,494', label: 'Total Meta impressions' },
      { value: '136,942', label: 'Unique reach' },
      { value: '59.5%', label: 'LinkedIn video view rate' },
      { value: '4,665', label: 'Top creative LPVs (Kontorstol)' },
      { value: '95', label: 'LP clicks from Ad2 Long 50 sec' },
    ],
    services: [
      'Meta Ads (Video)',
      'LinkedIn Ads (Video)',
      'GA4 Analytics',
      'Creative Testing',
      'Landing Page Optimisation',
      'B2C Marketing',
      'Lead Generation',
    ],
    takeaway:
      'Meta delivered the strongest traffic efficiency — NOK 2.15 per landing-page view with a 92.4% click-to-LPV rate. LinkedIn excelled at brand awareness (73.7K video views, 59.5% view rate) but was better suited to an awareness objective than direct traffic. The long-form video (Ad2 50 sec) on LinkedIn drove 62% of all LP clicks, proving depth of message outperforms brevity for considered membership decisions.',
  },
];
